import { render, staticRenderFns } from "./HistoryListPage.vue?vue&type=template&id=19e4718d&scoped=true&"
import script from "./HistoryListPage.vue?vue&type=script&lang=js&"
export * from "./HistoryListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e4718d",
  null
  
)

export default component.exports